// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"c44ad127","601":"0e75eef4"}[chunkId] + ".chunk.js";
};